import { proxy } from 'ajax-hook';
import { loadHbridge } from './globalLoader';

const ua = window.navigator.userAgent;


const isAliMP = ua.indexOf('AlipayClient') > -1 && ua.indexOf('MiniProgram') > -1;


if (isAliMP) {
  // 小程序请求代理到原生native
  proxy({
    // 请求发起前进入
    onRequest: async (config, handler) => {
      if (config.url.indexOf('.hellobike.com') > -1) {
        const { Native } = await loadHbridge();
        Native.callNative({
          method: 'request',
          timeout: false,
          params: {
            headers: config.headers,
            timeout: (config.xhr && config.xhr.timeout) || 10000,
            method: config.method,
            url: config.url,
            data: config.body,
          },
        }).then((res) => {
          const { status, headers, data } = res || {};

          let response = data;
          try {
            response = JSON.stringify(response);
          } catch (e) {
            // empty
          }

          handler.resolve(
            {
              config,
              headers,
              status,
              response,
            },
          );
        }).catch(() => {
          handler.reject({
            type: 'error',
            config,
          });
        });
      } else {
        handler.next(config);
      }
    },


    // 请求发生错误时进入，比如超时；注意，不包括http状态码错误，如404仍然会认为请求成功
    onError: (err, handler) => {
      handler.next(err);
    },
    // 请求成功后进入
    onResponse: (response, handler) => {
      handler.next(response);
    },
  });
}
